import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
}                                   from '@angular/core';
import { BaseComponent }            from '@core/bases/base-component/base.component';
import { DialogModalCommonService } from '@core/modals/dialog-modal-common/dialog-modal-common.service';
import { fadeInOut }                from '@shared/animations/fadeInOut';
import { LinkItemTypeEnum }         from '@shared/components/link-item/link-item.model';
import {
	SvgSizeEnum,
	SvgTypeEnum
}                                   from '@shared/components/svg/svg.model';
import {
	take,
	takeUntil
}                                   from 'rxjs/operators';

@Component( {
	selector: 'app-link-item[linkType][label]',
	templateUrl: './link-item.component.html',
	styleUrls: [ './link-item.component.scss' ],
	animations: [ fadeInOut ]
} )
export class LinkItemComponent extends BaseComponent implements OnInit {

	readonly linkTypeEnum = LinkItemTypeEnum;

	@Input() linkItemWrapperClass: string;

	@Input() isCollapsed = false;
	@Input() isDisabled = false;
	@Input() isHidden = false;
	@Input() isRenderable = true;

	@Input() svgSize: SvgSizeEnum;
	@Input() svgType: SvgTypeEnum;
	@Input() linkType: LinkItemTypeEnum;
	@Input() externalHref: string;
	@Input() label: string;
	@Input() labelSpare = '-';
	@Input() requestInProgress: boolean;
	@Input() showExternalLinkNavigationWarning: boolean;

	@Output() clickEventEmitter: EventEmitter<null> = new EventEmitter<null>();

	constructor(
		private _dialogModalCommonService: DialogModalCommonService
	) {
		super();
	}


	isActionAllowed(): boolean {
		switch ( this.linkType ) {
			case LinkItemTypeEnum.EMAIL:
			case LinkItemTypeEnum.EXTERNAL:
				return !!this.externalHref;

			case LinkItemTypeEnum.INTERNAL:
				return (
								 this.label || this.svgType
							 ) &&
							 !(
								 this.isCollapsed || this.isHidden || this.requestInProgress
							 );
		}
	}

	onClickEvent(): void {
		if ( this.isActionAllowed() ) {
			this.clickEventEmitter.emit();
		}
	}

	ngOnInit(): void {
		switch ( this.linkType ) {
			case LinkItemTypeEnum.EXTERNAL:
				if ( this.externalHref ) {
					this.externalHref =
						this.externalHref.match( '(http|https):\/\/' )?.length
						? this.externalHref
						: `http://${ this.externalHref }`;
				}

				if ( this.label ) {
					this.label = this.label?.replace( new RegExp( '(http|https):\/\/' ), '' );
				}
		}
	}

	onExternalLinkClick( $event: MouseEvent, externalLinkAnchor: HTMLAnchorElement ): void {
		if ( this.showExternalLinkNavigationWarning ) {
			$event.stopImmediatePropagation();
			$event.stopPropagation();
			$event.preventDefault();
			externalLinkAnchor.blur();

			this._dialogModalCommonService.showConfirmationDialog(
				this.getI18nString( false, 'shared.linkItem.externalLinkNavigationWarning' ),
				'openLink',
				null,
				`<span class="fst-italic fw-medium">${ this.externalHref }</span>`
			)
			.pipe(
				takeUntil( this.ngUnsubscribe ),
				take( 1 )
			)
			.subscribe( ( result: string ) => {
				window.open( this.externalHref, '_blank', 'noopener, noreferrer' );
			} );
		}
	}
}
